import { Tag, useWindowSize } from '@vlabs/uikit';
import cn from 'classnames';

import st from './AnalyticTag.module.sass';

interface AnalyticTagProps {
  icon: React.ReactNode;
  isAlarm?: boolean;
  isAlwaysAlarm?: boolean;
  label: string;
}

export function AnalyticTag({
  icon,
  isAlarm = false,
  isAlwaysAlarm = false,
  label,
}: AnalyticTagProps): React.JSX.Element {
  const windowSize = useWindowSize();

  return (
    <Tag
      className={cn(st.Tag, { [st.Tag_alarm]: isAlarm ?? isAlwaysAlarm })}
      data-testid="workspace.analyticEventCard.tagType"
      icon={icon}
      kind="neutral"
      size={windowSize.width < 1920 ? 'medium' : 'large'}
      value={label}
    />
  );
}
